import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  ViewChild,
  OnDestroy,
} from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import pdfMake from 'pdfmake/build/pdfmake';
import htmlToPdfmake from 'html-to-pdfmake';
import { Subject } from 'rxjs';
import { TDocumentDefinitions } from 'pdfmake/interfaces';
import { GenderReplacePipe } from '../../../../../../core/pipes/gender-replace.pipe';
@Component({
  selector: 'app-print-fba',
  standalone: true,
  imports: [CommonModule, DatePipe, GenderReplacePipe],
  templateUrl: './print-fba.component.html',
  styleUrl: './print-fba.component.scss',
})
export class PrintFbaComponent implements OnDestroy {
  /* eslint-disable @typescript-eslint/no-explicit-any */
  printData: any = null;
  /* eslint-disable @typescript-eslint/no-explicit-any */
  @Input() set fbaData(val: any) {
    this.initializeBehaviorData(val);
  }

  private async initializeBehaviorData(val: any) {
    this.printData = val;
    this.cd.detectChanges();
    this.initialized = true;
  }

  @ViewChild('pdfContent', { static: true }) pdfContent!: ElementRef;
  initialized = false;
  private readonly destroy$ = new Subject<void>();
  constructor(
    private readonly cd: ChangeDetectorRef,
    private readonly genderPipe: GenderReplacePipe
  ) {}
  async printPDF() {
    if (this.printData) {
      const pdfContent = document.getElementById('pdf-data');
      if (pdfContent) {
        // Convert HTML to pdfMake format
        let pdfMakeContent = htmlToPdfmake(pdfContent.innerHTML);
        if (Array.isArray(pdfMakeContent)) {
          pdfMakeContent = pdfMakeContent.map((contentItem: any) => {
            return {
              ...contentItem,
              pageBreak: 'avoid', // ✅ Prevents breaking inside the question container
              margin: [0, 10, 0, 10], // Adds spacing between sections
            };
          });
        }
        // Define the PDF document
        const documentDefinition: TDocumentDefinitions = {
          content: pdfMakeContent,
          pageMargins: [20, 20, 20, 20],
          footer: function (currentPage: number) {
            return {
              columns: [
                {
                  text: ``,
                  alignment: 'left',
                },
                {
                  text: `Powered by Insights to Behavior®`,
                  alignment: 'center',
                },
                {
                  text: `${currentPage}`,
                  alignment: 'right',
                },
              ],
              margin: [15, 0, 10, 0],
              color: '#475467',
            };
          },
          styles: {
            questionContainer: {
              margin: [0, 10, 0, 10], // Simulating padding
            },
            questionHeader: {
              marginBottom: 5,
              bold: true,
              fontSize: 14,
            },
            stepIndicator: {
              fillColor: '#d1f7d6', // Light green background
              color: '#22c55e', // Green text
              fontSize: 14,
              margin: [0, 0, 10, 0], // Spacing
              alignment: 'left',
            },
            questionText: {
              fontSize: 12,
              marginBottom: 5,
              color: '#475467',
            },
            datalabel: {
              lineHeight: 1.5,
              color: '#475467',
            },
            dataValue: {
              color: '#475467',
            },
            columns: {
              columnGap: 10,
            },
            chartImage: {
              alignment: 'center',
            },
          },
          defaultStyle: {
            columnGap: 10,
            fontSize: 12,
          },
        };

        // Generate and download the PDF
        pdfMake
          .createPdf(documentDefinition)
          .download(
            `${this.printData?.caseDetail.student.firstName} ${this.printData?.caseDetail.student.lastName}_Assessment.pdf`
          );
        this.initialized = false;
        this.ngOnDestroy();
      }
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  generateLI(item: any) {
    return JSON.stringify({
      listType: 'none',
      margin: [5, 5, 0, 0],
      columns: [
        {
          width: 'auto',
          canvas: [
            {
              type: 'ellipse',
              x: 5,
              y: 7,
              r1: 5,
              r2: 5,
              lineWidth: 1,
              lineColor: item.isSelected ? '#17B26A' : '#475467',
            },
            {
              type: 'ellipse',
              x: 5,
              y: 7,
              r1: 3,
              r2: 3,
              color: item.isSelected ? '#17B26A' : '#ffffff',
            },
          ],
          margin: [0, 0, 5, 0],
        },
        {
          width: '*',
          fontSize: 12,
          color: '#475467',
          text: this.genderPipe.transform(
            item.answer,
            this.printData?.caseDetail.student.firstName,
            this.printData?.caseDetail.student.gender
          ),
        },
      ],
    });
  }
}
